import { Modal, ModalTransition } from '@atlaskit/onboarding';
import { ExternalLink } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { ANALYTICS_INTRODUCTION_UI_SKIP, ANALYTICS_INTRODUCTION_UI_UNDERSTOOD } from '../../analytics';
import usePrivacySecurityAnalytics from '../../hooks/usePrivacySecurityAnalytics';
import IntroductionModalGraphic from './IntroductionModalGraphic.svg';
const IntroductionModal = () => {
  const {
    fireButtonEvent
  } = usePrivacySecurityAnalytics();
  const [isOpen, setIsOpen] = useState(true);
  const skipHandler = () => {
    setIsOpen(false);
    fireButtonEvent(ANALYTICS_INTRODUCTION_UI_SKIP);
  };
  const understoodHandler = () => {
    setIsOpen(false);
    fireButtonEvent(ANALYTICS_INTRODUCTION_UI_UNDERSTOOD);
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(Modal, {
    actions: [{
      onClick: understoodHandler,
      text: 'Understood'
    }, {
      onClick: skipHandler,
      text: 'Skip'
    }],
    heading: "New Privacy & Security tab in Marketplace",
    image: IntroductionModalGraphic
  }, /*#__PURE__*/React.createElement("p", null, "We have introduced a", ' ', /*#__PURE__*/React.createElement(ExternalLink, {
    href: "https://developer.atlassian.com/platform/marketplace/security-privacy-tab/#new-privacy---security-tab-in-the-marketplace-listing"
  }, "new privacy and security tab"), ' ', "in the Marketplace listing for cloud apps. This new tab will provide detailed information collected from respective app partners on the privacy, security, data handling, and compliance practices followed by the app. The information will be collected via a questionnaire, which can be filled either through an API or UI web form.")));
};
export default IntroductionModal;